import dynamic from 'next/dynamic'

import { Loading } from 'common/widgets'


const FormsBlock = dynamic(() => import('./FormsBlock'), { loading: () => <Loading isLoading /> })

export default FormsBlock
